<template>
    <div id="popup-box" @keydown.esc="closePopup">
        <div class="container">
            <component :is="popupComponent" :popupData="popupData"/>
        </div>
    </div>
</template>

<script>
    import {mapState} from 'vuex'

    export default {
        name: 'popup-component',
        data() {

            return {
                show: false
            }
        },
        computed: {
            ...mapState({
                popupComponent: state => state.popupComponent,
                popupData: state => state.popupData,
            }),
        },
        methods: {
            closePopup() {
                console.log('close')
            }
        }
    }
</script>

<style scoped>

</style>
